export interface Product {
  id: string
  name: string
  price: number
  description: string
  availableIn: string
  image: string
  colors?: string[]
  sizes?: string[]
  features?: string[]
}

export const products: Product[] = [
  {
    id: 'hoodie',
    name: 'Che Ko Official Hoodie',
    price: 45,
    description:
      'Premium quality hoodie featuring the Che Ko Martial Arts logo. Perfect for training or casual wear.',
    availableIn: 'Available in 3 colors & designs',
    image:
      'https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=800&h=800&fit=crop',
    colors: ['Black', 'Gray', 'Navy'],
    sizes: ['S', 'M', 'L', 'XL', '2XL'],
    features: [
      'Premium cotton blend material',
      'Embroidered Che Ko logo',
      'Comfortable fit for training',
      'Machine washable',
      'Available in multiple colors',
    ],
  },
  {
    id: 'tshirt',
    name: 'Training T-Shirt',
    price: 25,
    description:
      'Lightweight training t-shirt designed for maximum comfort during intense workouts and classes.',
    availableIn: 'Available in 3 colors & designs',
    image:
      'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=800&h=800&fit=crop',
    colors: ['White', 'Black', 'Red'],
    sizes: ['S', 'M', 'L', 'XL', '2XL'],
    features: [
      'Moisture-wicking fabric',
      'Breathable material',
      'Screen-printed logo',
      'Lightweight and comfortable',
      'Perfect for training',
    ],
  },
]

export function getProductById(id: string): Product | undefined {
  return products.find((product) => product.id === id)
}
